import axios from "axios";

import { ENDPOINT, bookedEnv } from "../../constant/environment";
import { decryptData, encryptData, getHeaderConfig } from "../../utils/api/encryption";
import { consoleLog } from "../../utils/consoleLog/consoleLog";
import { isValidJWT } from "../../utils/authentication/isValidJWT";

export async function getItinerariesListAPI(
  accessJWT: string,
  userId: string,
  filter: "upcoming" | "past" | "cancelled" | "saved" | "current" | "shared",
  skip: number,
  limit: number
) {
  const URL = `${ENDPOINT}/app/v1/users/itineraris`;

  let config = getHeaderConfig(null, accessJWT);

  const body = {
    userId: userId,
    filter: filter,
    skip: skip,
    limit: limit,
    bookedEnv,
  };
if (!accessJWT || !isValidJWT(accessJWT)) return null;
  try {
    if (!userId || !accessJWT) return null;
    consoleLog(["API REQUEST", URL, body]);
    const response = await axios.post(URL, encryptData(body), config);
    if (response?.data) {
      const decryptedData = decryptData(response?.data);
      const decryptedResponse = decryptedData ? JSON.parse(decryptedData) : null;
      consoleLog(["API RESPONSE", URL, decryptedResponse]);
      return decryptedResponse
    } else return null;
  } catch (error) {
    return null;
  }
}
